import * as Yup from "yup";

// validateGameForm
const validGameForm = Yup.object().shape({
  date: Yup.string()
    .matches(
      /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/,
      "Ungültiges Format, nutze YYYY-MM-DD"
    )
    .required("Benötigte Angabe"),
  time: Yup.string()
    .matches(
      /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
      "Ungültiges Format, nutze XX:YY"
    )
    .required("Benötigte Angabe"),
  team: Yup.object().required("Benötigte Angabe"),
  opponent: Yup.object().required("Benötigte Angabe"),
  location: Yup.object().required("Benötigte Angabe"),
});

const validation = {
  validGameForm
};

export default validation;